import { z } from 'zod';

const conversationID = z.string().nullable();
const authToken = z.object({
    token: z.string(),
});
const messagingAttachment = z.object({
    path: z.string().optional(),
    content_type: z.string().optional(),
    url: z.string().optional(),
});
const uploadMessageAttachments = z.array(messagingAttachment);
z.object({
    text: z.string(),
    attachments: z.array(messagingAttachment).optional(),
    clientMessageId: z.string().optional(),
});
const messagingMessageResponse = z.object({
    id: z.string(),
});
const presentationStyleWeb = z.enum(['modal', 'newtab']);
const triggerId = z.enum(['buy', 'offer', 'seller_offer']);
const messagingTriggerAction = z.object({
    id: triggerId,
    label: z.string(),
    style: z.enum(['solid', 'outline']),
    // e.g modal is default, newtab is used for external links
    presentation_style_web: presentationStyleWeb.optional(),
    presentation_style_mobile: z.string().optional(),
});
z.object({
    peer_id: z.string(),
    ad_id: z.string(),
    trigger_id: triggerId,
});
const startTransactionResponse = z.object({
    flow_url: z.string(),
});
const messagingTriggerActionsResponse = z.object({
    triggers: z.array(messagingTriggerAction),
});
const unreadMessages = z.object({
    unread: z.number(),
    pollingTime: z.number(),
});
const channelInfo = z.object({
    channel: z.object({
        urn: z.string(),
        ad_id: z.string(),
        ad_url: z.string(),
        seller_id: z.string(),
        buyer_id: z.string(),
        item_id: z.string(),
        subject: z.string(),
        price: z.number(),
        category_id: z.string(),
        ad_state: z.string(),
        id: z.string(),
        cid: z.string(),
        created_at: z.string(),
        updated_at: z.string(),
        members: z.array(z.object({
            user_id: z.string(),
        })),
        message_counters: z.object({
            total: z.number(),
            messages: z.number(),
            pending: z.number(),
        }),
    }),
});
const ongoingTransaction = z.object({
    transaction_id: z.string(),
    seller_id: z.string(),
    buyer_id: z.string(),
    ad_id: z.string(),
    state: z.string(),
    transaction_type: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});
const ongoingTransactionsResponse = z.object({
    transactions: z.array(ongoingTransaction),
});
const reportUserReason = z.object({
    id: z.string(),
    text: z.string(),
    additional_text: z.string().optional(),
});
z.object({
    reason: reportUserReason,
    reported_user_id: z.string(),
    ad_id: z.string(),
    item_id: z.string(),
});
const reportUserReasonsResponse = z.object({
    reasons: z.array(reportUserReason),
});
z.object({
    ad_id: z.string(),
    subject: z.string().optional(),
    price: z.number().optional(),
    image: z.string().optional(),
});
const sendFirstContactResponse = z.object({
    body: z.string(),
    acceptTermsConds: z.boolean(),
});

export { authToken, channelInfo, conversationID, messagingAttachment, messagingMessageResponse, messagingTriggerAction, messagingTriggerActionsResponse, ongoingTransaction, ongoingTransactionsResponse, presentationStyleWeb, reportUserReason, reportUserReasonsResponse, sendFirstContactResponse, startTransactionResponse, triggerId, unreadMessages, uploadMessageAttachments };
//# sourceMappingURL=zod.js.map
